import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Correct from './correctAnswer';
import Incorrect from './incorrectAnswer';
import { appendScript } from '../../../../utils/appendScript';
import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';

const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
		feedback,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
		feedback,
	};
};

const McqFeedback = ({ feedback }) => {
	useEffect(() => {
		appendScript('testMCQ');
	}, []);

	let UserAndCorrectAnswerList = '';

	UserAndCorrectAnswerList = feedback.map((que, index) => {
		let {
			correct_answers,
			question,
			choices,
			imgchoices,
			default_feedback,
		} = que.question;
		let { user_answer, score } = que.answers;
		return (
			<span key={user_answer} className="container">
				<div className="container clearfix step-tquestion-wrapper">
					<br />
					<div
						className=" step-tquestion-content"
						dangerouslySetInnerHTML={{ __html: question }}
					/>
				</div>
				{score === 1 ? (
					<Correct
						index={index}
						userAnswer={user_answer}
						correctAnswer={correct_answers[0]}
						choices={choices}
						imgChoices={imgchoices}
						default_feedback={default_feedback}
					/>
				) : (
					<Incorrect
						index={index}
						userAnswer={user_answer}
						correctAnswer={correct_answers[0]}
						choices={choices}
						imgChoices={imgchoices}
						default_feedback={default_feedback}
						score={score}
					/>
				)}
			</span>
		);
	});

	return (
		<section className="quiz-area-options ">
			{UserAndCorrectAnswerList}
			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(McqFeedback);
